class ProductSelector extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");

    this.initForm();

    this.rechargeContainer = this.querySelector(".rc-widget-injection-parent");
    this.initRechargeObserver();

    this.options = this.querySelectorAll(".selection-list .option");
    this.options.forEach(option => option.addEventListener("click", () => this.selectOption(option)));

    this.selectedOption = this.querySelector(".option-selected");
    if (this.selectedOption) {
      this.setVariantFromOption(this.selectedOption);
    }

    this.initPlansDropdown();
  }

  initForm() {
    if (this.form.elements.id === undefined) {
      const formInput = document.createElement("input");
      formInput.setAttribute("type", "hidden");
      formInput.setAttribute("name", "id");
      this.form.appendChild(formInput);
    }
  }

  initRechargeObserver() {
    if (!this.rechargeContainer) return;
    const observer = new MutationObserver(() => {
      observer.disconnect();
      while (this.rechargeContainer.firstChild) this.rechargeContainer.removeChild(this.rechargeContainer.firstChild);
    });
    observer.observe(this.rechargeContainer, {
      childList: true,
      subtree: true,
    });
  }

  setVariant(variantId, sellingPlan = undefined) {
    this.variantId = this.form.elements.id.value = variantId;

    if (typeof sellingPlan === "string") {
      if (this.form.elements.selling_plan === undefined) {
        const formInputSellingPlan = document.createElement("input");
        formInputSellingPlan.setAttribute("type", "hidden");
        formInputSellingPlan.setAttribute("name", "selling_plan");
        this.form.appendChild(formInputSellingPlan);
      }

      this.form.elements.selling_plan.value = sellingPlan;
      this.sellingPlan = sellingPlan;
    } else {
      if (this.form.elements.selling_plan !== undefined) {
        this.form.elements.selling_plan.parentElement.removeChild(this.form.elements.selling_plan);
      }
    }
  }

  setVariantFromOption(option) {
    this.setVariant(option.dataset.variantId, option.dataset.sellingPlan);
  }

  selectOption(option) {
    this.selectedOption = option;
    this.setVariantFromOption(option);
    this.options.forEach(option => option.classList.remove("option-selected"));
    this.selectedOption.classList.add("option-selected");
  }

  initPlansDropdown() {
    this.plansList = this.querySelector(".plans-list");
    if (!this.plansList) return;

    this.plansDropdown = this.querySelector(".plans-dropdown");
    this.plansDropdown.addEventListener("click", () => this.plansList.classList.remove("c-list-hidden"));

    this.plansOptions = this.querySelectorAll(".plans-list .plan-option");
    this.plansOptions.forEach(option => {
      option.style.width = `${this.querySelector(".placeholder").offsetWidth}px`;
      option.addEventListener("click", event => {
        event.stopPropagation();
        this.setPlanOption(option);
        this.plansList.classList.add("c-list-hidden");
      });
    });
  }

  setPlanOption(option) {
    this.selectedOption.dataset.sellingPlan = option.dataset.sellingPlan;
    this.setVariantFromOption(this.selectedOption);
    this.selectedOption.querySelector(".plan-name").textContent = option.textContent;
    this.selectedOption.querySelector(".percentOff").textContent = option.dataset.percentage;
    this.selectedOption.querySelector(".pricing .current").textContent = option.dataset.price;
  }
}

customElements.define("product-selector", ProductSelector);
